import {GroupRow} from "../group-row/group-row";

export class Table {
  groupRows: GroupRow[] = [];
  groupRowDictionary: {[id: string]: GroupRow} = {}

  constructor(groupRows: GroupRow[]) {
    this.groupRows = groupRows;
  }

  static getById(rowId: string, table: Table): GroupRow{
    return table.groupRowDictionary[rowId]
  }
  static addNewGroupRow(groupRow: GroupRow, table: Table): GroupRow{
    table.groupRowDictionary[groupRow.id] = groupRow
    table.groupRows.push(groupRow)
    return groupRow
  }
}
